<template>
  <section class="metric-radio-string" :class="{ enabled: !isEmpty }">
    <div v-for="(answer, $index) in question.answers" :key="$index">
      <hr />
      <p>{{ answer.text }}</p>
      <b-progress
        :value="isEmpty ? 0 : answer.score"
        variant="lima"
        :max="100"
      ></b-progress>
      <div
        class="fluid-label"
        :style="{ width: `${isEmpty ? 0 : answer.score}%`, 'min-width': '13%' }"
      >
        <span>{{ isEmpty ? 0 : answer.score }}%</span>
      </div>
    </div>
  </section>
</template>

<script>
const props = {
  question: {
    type: Object,
    required: true,
  },
  isEmpty: {
    type: Boolean,
    required: false,
  },
}

export default {
  props,
  computed: {
    score: function() {
      return this.question.score
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.metric-radio-string {
  padding: 0 1.4rem 1.4rem;

  hr {
    margin-top: 0;
    margin-bottom: 2rem;
  }

  p {
    font-size: 24px;
    text-transform: capitalize;
    color: map-get($theme-colors, 'gray04');
  }

  .progress {
    background: map-get($theme-colors, 'light');
    border: 1px solid map-get($theme-colors, 'gray-dark');
    border-radius: 30px;
    max-height: 12px;
  }

  .fluid-label {
    color: map-get($theme-colors, 'gray03');
    text-align: right;
    width: 100%;
    max-width: 100%;
    word-break: break-all;
  }

  &.enabled {
    .fluid-label {
      span {
        color: map-get($theme-colors, 'lima');
        font-size: 36px;
        font-weight: 500;
      }
    }
  }
}
</style>

<style lang="scss">
.metric-radio-string {
  .progress-bar {
    border-radius: 30px;
  }
}
</style>
